app.service("stores", function(loading,console, selectCity) {
	function setElements() {
		
	}
	function setEvents() {
		
	}
	function init() {
		setElements();
		setEvents();
	}

	return {
		init: init
	};
});